// extracted by mini-css-extract-plugin
export default {"root":"FormAction_root__Y+eAo","firstRow":"FormAction_firstRow__x5mE4","textArea":"FormAction_textArea__zDTO-"};